import { GET_CANCEL_REASON_REQUESTED, GET_CANCEL_TRIP_REQUESTED, GET_RATE_CALCULATION_REQUESTED, GET_REFUND_PRICE_REQUESTED, GET_TRIP_CHECKOUT_REQUESTED,GET_TRIP_SLAB_REQUESTED, GET_RENATAL_SLAB_REQUESTED, GET_CLEAR_RATE_CALCULATION, GET_CLEAR_DIRECTION } from "resources/actionTypes";

export function getRateCalculation(userRateCalculation) {
  const data = {
    userRateCalculation: userRateCalculation,
  };
  return {
    type: GET_RATE_CALCULATION_REQUESTED,
    payload: data,
  };
}
export function getTripCheckout(userTripCheckout, navigate) {
  const data = {
    userTripCheckout: userTripCheckout,
    navigate: navigate,
  };
  return {
    type: GET_TRIP_CHECKOUT_REQUESTED,
    payload: data,
  }
}
export function getTripSlab(userTripSlab){
  const data = {
    userTripSlab:userTripSlab,
  }
  return {
    type:GET_TRIP_SLAB_REQUESTED,
    payload:data,
  }
}
export function getCancelTrip(userCancelTrip,navigate){
  const data = {
    userCancelTrip : userCancelTrip,
    navigate:navigate
  }
  return {
    type:GET_CANCEL_TRIP_REQUESTED,
    payload:data
  }
}
export function getCancelReason(userCancelReason){
  const data = {
    userCancelReason: userCancelReason
  }
  return {
    type:GET_CANCEL_REASON_REQUESTED,
    payload:data
  }
}
export function getRefundPrice(userRefundPrice){
  const data = {
    userRefundPrice:userRefundPrice,
  }
  return{
    type:GET_REFUND_PRICE_REQUESTED,
    payload:data
  }
}

export function getRentalSlab(userRentalSlab) {
  const data = {
    userRentalSlab: userRentalSlab,
  };
  return {
    type: GET_RENATAL_SLAB_REQUESTED,
    payload: data,
  };
}
export function getClearRateCalculation() {
  return {
    type: GET_CLEAR_RATE_CALCULATION,
  };
}